import { render, staticRenderFns } from "./translatorlist.vue?vue&type=template&id=9be3231a&scoped=true&"
import script from "./translatorlist.vue?vue&type=script&lang=js&"
export * from "./translatorlist.vue?vue&type=script&lang=js&"
import style0 from "./translatorlist.vue?vue&type=style&index=0&id=9be3231a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be3231a",
  null
  
)

export default component.exports